<div fxLayout="column" fxFlex="1 0 auto">
    <div fxLayout="column" class="neq-page-wrapper">
        <div fxLayout="row">
            <neq-select-autocomplete #select fxFlex="20%" [dataSource]="fetchColumn"
                            defaultLabel="{{'label.common.search' | translate}}"
                            bindLabel="header" (change)="changeSelectedColumn($event)"
                            [(ngModel)]="selectedColumnHeader"
                            [paginatedResults]="false">
            </neq-select-autocomplete>
            <div fxLayoutAlign="start center">
                <button pButton class="neq-primeng-button primeng-flat"
                        [disabled]="!selectedColumnHeader"
                        (click)="addColumn()">
                    <neq-icon svgIcon="plus"></neq-icon>
                </button>
            </div>
            <div fxFlex></div>
            <div fxLayoutAlign="end center" class="neq-action-button">
                <button pButton
                  [disabled]="hasBlockedError || !hasChange() || isLoading"
                  class="neq-primeng-button primeng-flat"
                  (click)="save()"
                  [matTooltip]="'msg.common.icon.save' | translate">
                  <neq-icon svgIcon="enregistrer"></neq-icon>
                </button>
            </div>
        </div>
        <neq-table
            [sessionId]="'rawMaterialsMutliEditTable'"
            [cols]="cols"
            [onRequestData]="refreshTable"
            [eventDataChecked]="eventDataChecked"
            [loading]="isLoading"
            [initalRawMaterialsData]="initalRawMaterialsData"
            [nutrientsData]="rawMaterialsNutrientsMap"
            [initNutrientsData]="initialRawMaterialsNutrientsData"
            [noPagination]="true">
        </neq-table>
    </div>
</div>